import { confirmModal } from "../constants/refs"
import { ConfirmModalOptions } from "../components/ConfirmModal"

type UseConfirmModal = {
  openConfirmModal(options: ConfirmModalOptions): void
  closeConfirmModal(): void
}

const useConfirmModal = (): UseConfirmModal => {
  const openConfirmModal = (options: ConfirmModalOptions): void => confirmModal.current?.open(options)
  const closeConfirmModal = (): void => confirmModal.current?.close()

  return { openConfirmModal, closeConfirmModal }
}

export default useConfirmModal
